// extracted by mini-css-extract-plugin
export default {"buyerProtectionModalLink":"ModalLink-buyerProtectionModalLink","label":"ModalLink-label"};